// SlideContentList.js
import React, { useState } from 'react';

function SlideContentList({ processedSlides, onCopyText }) {
  const [copiedSlideIndex, setCopiedSlideIndex] = useState(null);

  const handleCopySlide = (slide, index) => {
    onCopyText(slide);
    setCopiedSlideIndex(index);
    setTimeout(() => {
      setCopiedSlideIndex(null);
    }, 2000);
  };

  return (
    <div className="slide-content-section">
      <h3>Slide Content</h3>
      {processedSlides.map((slide, index) => (
        <div key={index} className="slide-content-card">
          <div className="slide-content-header">
            <span className="slide-number">Slide #{index + 1}</span>
            <button
              className={`copy-text-inline ${copiedSlideIndex === index ? 'copied' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                handleCopySlide(slide, index);
              }}
              title={copiedSlideIndex === index ? 'Copied!' : 'Copy slide text'}
            >
              {copiedSlideIndex === index ? (
                <svg 
                  width="16" 
                  height="16" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              ) : (
                <svg 
                  width="16" 
                  height="16" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
              )}
            </button>
          </div>
          <div className="slide-content">
            {slide.extractedContent?.heading && (
              <div className="content-item">
                <strong>Heading:</strong>
                <p>{slide.extractedContent.heading}</p>
              </div>
            )}
            {slide.extractedContent?.subheading && (
              <div className="content-item">
                <strong>Subheading:</strong>
                <p>{slide.extractedContent.subheading}</p>
              </div>
            )}
            {slide.extractedContent?.bulletPoints?.length > 0 && (
              <div className="content-item">
                <strong>Points:</strong>
                <ul>
                  {slide.extractedContent.bulletPoints.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default SlideContentList;